import { css } from 'linaria';

export const questionAccordion = css`
  && {
    width: 877px;

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const questionText = css`
  && {
    margin-bottom: 20px;
  }
`;
